if (!customElements.get('image-accordion')) {
  customElements.define(
    'image-accordion',
    class ImageAccordion extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setPaginationState();
        this.setBlocksState();
        this.setEventListeners();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          carousel: this.querySelector('swiper-container'),
          dots: this.querySelectorAll('[js-image-accordion="dot"]'),
          blocks: this.querySelectorAll('[js-image-accordion="block"]'),
        };
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        if (this.nodeSelectors.carousel) {
          /**
           * Handles the real index change.
           * - Updates the pagination and block states.
           */
          this.nodeSelectors.carousel.addEventListener('swiperrealindexchange', () => {
            this.setPaginationState();
            this.setBlocksState();
          });

          /**
           * Handle pagination click events.
           * - Navigates to the related slide.
           */
          [...this.nodeSelectors.dots].forEach((element) => {
            element.addEventListener('click', (event) => {
              this.nodeSelectors.carousel.swiper.slideToLoop(Number(event.currentTarget.dataset.realIndex));
            });
          });

          /**
           * Handle block heading click events.
           * - Navigates to the related slide.
           */
          [...this.nodeSelectors.blocks].forEach((block) => {
            const heading = block.querySelector('[js-image-accordion="heading"]');

            if (heading) {
              heading.addEventListener('click', () => {
                this.nodeSelectors.carousel.swiper.slideToLoop(Number(block.dataset.realIndex));
              });
            }
          });
        }
      }

      /**
       * Sets the state of the content blocks.
       */
      setBlocksState() {
        if (!this.nodeSelectors.carousel?.swiper) {
          return;
        }

        this.nodeSelectors.blocks.forEach((element) => {
          const slideUp = element.querySelector('[js-image-accordion="slideUp"]');

          if (Number(element.dataset.realIndex) === this.nodeSelectors.carousel.swiper.realIndex) {
            if (slideUp) {
              slideUp.style.maxHeight = `${slideUp.scrollHeight}px`;
            }

            element.classList.add('is-active');
            return;
          }

          if (slideUp) {
            slideUp.style.maxHeight = '0px';
          }

          element.classList.remove('is-active');
        });
      }

      /**
       * Sets the state of the pagination dots, based on the current slide.
       */
      setPaginationState() {
        if (!this.nodeSelectors.carousel?.swiper) {
          return;
        }

        const swiper = this.nodeSelectors.carousel.swiper;
        const realIndex = swiper.realIndex;
        const activeDot = [...this.nodeSelectors.dots].find(({ dataset }) => Number(dataset.realIndex) === realIndex);

        /**
         * Handle the base state for all dots.
         */
        this.nodeSelectors.dots.forEach((element) => {
          const dotRealIndex = Number(element.dataset.realIndex);
          const isBefore = dotRealIndex < realIndex;
          const isAfter = dotRealIndex > realIndex;

          if (isBefore) {
            /**
             * If the slide is previous, force the finished animation state.
             * - This avoids waiting for the animation to finish, which would show multiple dots animating.
             */
            element.classList.add('is-finished');
            element.classList.remove('is-active');
            return;
          }

          if (isAfter) {
            element.classList.remove('is-active');
            element.classList.remove('is-finished');
          }
        });

        /**
         * Handle the state for the active dot.
         */
        if (activeDot) {
          requestAnimationFrame(() => {
            activeDot.classList.add('is-active');
          });
        }
      }
    }
  );
}
